// removed by extract-text-webpack-plugin
module.exports = {"body":"_-src-components-MoveToModal-index---body---1Kkcy","description":"_-src-components-MoveToModal-index---description---1i675","name":"_-src-components-MoveToModal-index---name---35XTc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MoveToModal/index.css
// module id = 724
// module chunks = 1